import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { getEditSessionNavigation, installEditSessionNavigation } from './editSessionNavigation';
//import { commandDispatcher, queryExecutor } from '@/_core/cqrs';

import { useAppSlidePanelModule } from '@/store/global/appComponents/slidePanel';
import { CloseSlidePanel } from '@/store/global/appComponents/slidePanel/actions';

import { routes as rootRouts } from './rootRoutes';
import { routes as mainrouts } from './mainRoutes';
import { queryExecutor } from '@/_core/cqrs';
import { trackingService } from '@/_core/tracking/trackingService';
import { TrackedPage } from '@/_core/tracking/trackedpages';

import intercomService from '@/_core/utils/intercom';

Vue.use(VueRouter);

const reducedRecipientShellMode = 1;
const recipientRouteNames = ['publishedStorymapPrivateRelease', 'publishedStorymapPrivate', 'storymapRelease', 'storymap'];
const isReducedPublishedRecipientShell = (): boolean =>
    initAppData.publishedStorymapBootstrap?.shellMode === reducedRecipientShellMode;

export const selectRoutes = () => {
    if (isReducedPublishedRecipientShell()) {
        return mainrouts.filter((route) => recipientRouteNames.includes(String(route.name)));
    }

    return initAppData.isInWsContext ? mainrouts : rootRouts;
};

const routes = [
    ...selectRoutes(),
    {
        path: '*',
        component: () => import(/* webpackChunkName: "PageNotFound" */ '@/PageNotFound.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes,
});

let initialized = false;
let lastPage: Route = null;
export const initializeMainRouter = () => {
    if (initialized) return;
    initialized = true;
    installEditSessionNavigation(router);

    router.beforeEach((to, from, next) => {
        queryExecutor.abortAllRuningQuery();

        const slidePanelStore = useAppSlidePanelModule();
        slidePanelStore.dispatch(new CloseSlidePanel());

        if (to.meta && typeof to.meta.pageVisiteEvent == 'number') {
            trackingService.TrackPageVisit({
                pageName: TrackedPage[to.meta.pageVisiteEvent],
                properties: {},
            });
        }

        next();
    });

    router.afterEach((to, from) => {
        lastPage = from;

        if (!isReducedPublishedRecipientShell()) {
            intercomService.update();
        }
    });
};

export const goBack = () => {
    const target = lastPage != null && lastPage != router.currentRoute ? lastPage.fullPath : '/';
    const navigation = getEditSessionNavigation(router);
    if (navigation) {
        return navigation.navigate(target).then(result => {
            if (result.type === 'failed') console.error('Back navigation failed', result.error);
            return result;
        });
    }
    return router.push(target);
};

export default router;
